import { useMutation } from 'react-query';
import { RemoteRegisterRepo } from '@repository/register/RegisterRepo';
import JoinRq from '@domain/rq/register/JoinRq';

const remoteRegisterRepo = new RemoteRegisterRepo();

const fetchSaveJoinContent = async (rq: JoinRq) => {
  const { data } = await remoteRegisterRepo.fetchSaveJoinContent(rq);
  return data;
};

export function useSaveJoinContent() {
  return useMutation((rq: JoinRq) => fetchSaveJoinContent(rq));
}

const fetchCheckDuplicationID = async (id: string) => {
  const { data } = await remoteRegisterRepo.fetchCheckDuplicationID(id);
  return data;
};

export function useCheckDuplicationId() {
  return useMutation((id: string) => fetchCheckDuplicationID(id));
}

const checkDuplicationEmail = async (email: string) => {
  const { data } = await remoteRegisterRepo.fetchCheckDuplicationEmail(email);
  return data;
};

export function useCheckDuplicationEmail() {
  return useMutation((email: string) => checkDuplicationEmail(email));
}
